export const NotificationIds = {
  AutoRefinancingDeactiveCreation: 'showAutoRefinancingDeactiveCreation',
}
